import {
    allFetch
} from "../Domain";


/**
 * @description 系統設定
 */
export const SystemSettings = (() => {
    /**
     * @description 特殊系統設定查詢
     * @returns res
     */
    const SystemSettingSearch = async (obj={
        ssm_name:''
    }) => {
        return await allFetch("SystemSettings/SystemSettingSearch", obj);
    }
    /**
     * @description 特殊系統設定修改
     * @param {string}  ssm_id 流水號
     * @param {string}  value_json 內容
     * @returns res
     */
    const SystemSettingUpdate = async (obj = {
        ssm_id: '',
        value_json: new Array()
    }) => {
        return await allFetch("SystemSettings/SystemSettingUpdate", obj);
    }

    return {
        SystemSettingSearch,
        SystemSettingUpdate,
    }
})();